export default __webpack_public_path__ + "56a1bbbd722547683a6c50e66009dd0d.png";